import { setAppearance, useAppearance, type Appearance } from "./appearance";

/** Device preference only: changing appearance never submits or remounts a form. */
export function AppearancePicker() {
  const appearance = useAppearance();
  return <label className="appearance-picker">Appearance
    <select aria-label="Appearance" value={appearance} onChange={(event) => setAppearance(event.target.value as Appearance)}>
      <option value="light">Light</option><option value="dark">Dark</option><option value="system">System</option>
    </select>
  </label>;
}
